import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';

const ConseilsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = ['Construction', 'Écologie', 'Immobilier', 'Vie quotidienne', 'Divers'];

  const articles = [
    {
      id: 1,
      title: 'Isolation des combles et récupérateur d\'eau de pluie : confort, économies et durabilité',
      date: '16 octobre 2025',
      categories: ['Construction', 'Écologie'],
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
      excerpt: 'Découvrez comment l\'isolation des combles et le récupérateur d\'eau peuvent améliorer votre confort et réduire vos factures.'
    },
    {
      id: 2,
      title: 'Les 40 ans de MRTP SARL : Une célébration humaine et inspirante',
      date: '1 octobre 2025',
      categories: ['Divers'],
      image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800',
      excerpt: 'Il y a 40 ans, MRTP SARL ouvrait ses portes avec un rêve : construire des maisons qui ne…'
    },
    {
      id: 3,
      title: 'Économie d\'énergie : la clé d\'une maison plus performante',
      date: '16 septembre 2025',
      categories: ['Construction', 'Écologie'],
      image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800',
      excerpt: 'Les solutions pour réduire votre consommation énergétique et améliorer la performance de votre maison.'
    },
    {
      id: 4,
      title: 'Plan maison : maison à étage ou maison avec sous-sol, laquelle choisir ?',
      date: '1 septembre 2025',
      categories: ['Construction', 'Divers'],
      image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800',
      excerpt: 'Et si le choix de votre plan maison était bien plus qu\'une question d\'esthétique ? Découvrez nos conseils.'
    },
    {
      id: 5,
      title: 'Isolation des cloisons et adoucisseur d\'eau : deux alliés pour économiser l\'énergie',
      date: '5 août 2025',
      categories: ['Construction', 'Écologie', 'Vie quotidienne'],
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
      excerpt: 'Et si les vraies économies d\'énergie ne se voyaient pas forcément au premier coup d\'œil ?'
    },
    {
      id: 6,
      title: 'Plan de maison en L ou maison rectangulaire : optimisez votre terrain et votre budget',
      date: '1 août 2025',
      categories: ['Construction', 'Immobilier'],
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
      excerpt: 'Vous rêvez d\'une maison qui ne ressemble pas à celle du voisin… mais sans exploser le budget ?'
    },
    {
      id: 7,
      title: 'Trouver votre terrain à vendre idéal : La première pierre de votre maison neuve',
      date: '16 juillet 2025',
      categories: ['Immobilier', 'Construction'],
      image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800',
      excerpt: 'L\'aventure de votre future maison débute ici : la recherche du terrain à vendre parfait.'
    },
    {
      id: 8,
      title: 'Isolation des Murs : Le Duo Gagnant Domotique & Confort Durable',
      date: '1 juillet 2025',
      categories: ['Construction', 'Écologie', 'Vie quotidienne'],
      image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800',
      excerpt: 'Découvrez comment combiner isolation performante et domotique pour un confort optimal.'
    },
    {
      id: 9,
      title: 'Primo-accédants : construire une maison sans dépasser votre budget',
      date: '19 juin 2025',
      categories: ['Construction', 'Immobilier', 'Écologie'],
      image: 'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=800',
      excerpt: 'Faire construire sa première maison est un rêve pour beaucoup. Entre le budget, les démarches et les choix techniques…'
    }
  ];

  const filteredArticles = selectedCategory === 'all' 
    ? articles 
    : articles.filter(article => article.categories.includes(selectedCategory));

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div
        className="relative h-96 bg-cover bg-center flex items-center"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1600)'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-white">
            <div className="flex items-center text-sm mb-4">
              <Link to="/" className="opacity-90 hover:opacity-100">Accueil</Link>
              <ChevronRight className="w-4 h-4 mx-2" />
              <span>Nos conseils</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold">Nos conseils et actualités</h1>
          </div>
        </div>
      </div>

      {/* Categories Filter */}
      <div className="bg-gray-50 py-8 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            <Button
              variant={selectedCategory === 'all' ? 'default' : 'outline'}
              onClick={() => setSelectedCategory('all')}
              className={selectedCategory === 'all' ? 'bg-[#c4d600] hover:bg-[#b0c200] text-gray-800' : ''}
            >
              Tous les articles
            </Button>
            {categories.map((category) => (
              <Button
                key={category}
                variant={selectedCategory === category ? 'default' : 'outline'}
                onClick={() => setSelectedCategory(category)}
                className={selectedCategory === category ? 'bg-[#c4d600] hover:bg-[#b0c200] text-gray-800' : ''}
              >
                {category}
              </Button>
            ))}
          </div>
        </div>
      </div>

      {/* Articles Grid */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.map((article) => (
              <Link
                key={article.id}
                to={`/conseil/${article.id}`}
                className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <Calendar className="w-4 h-4 mr-2" />
                    {article.date}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-[#c4d600] transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">{article.excerpt}</p>
                  <div className="flex flex-wrap gap-2">
                    {article.categories.map((cat, index) => (
                      <span
                        key={index}
                        className="text-xs bg-gray-100 text-gray-600 px-3 py-1 rounded-full"
                      >
                        {cat}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center mt-12 space-x-2">
            <Button variant="outline" className="w-10 h-10">1</Button>
            <Button variant="outline" className="w-10 h-10">2</Button>
            <Button variant="outline" className="w-10 h-10">3</Button>
            <Button variant="outline" className="w-10 h-10">4</Button>
            <Button variant="outline" className="px-4">›</Button>
            <Button variant="outline" className="px-4">»</Button>
          </div>
        </div>
      </div>

      {/* Newsletter CTA */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Restez connecté</h2>
          <p className="text-lg text-gray-600 mb-8">
            Restez informé de toute notre actualité et de nos bons plans
          </p>
          <Button asChild className="bg-[#c4d600] hover:bg-[#b0c200] text-gray-800 font-semibold text-lg px-8 py-6">
            <Link to="/newsletter">M'inscrire à la newsletter</Link>
          </Button>
          
          <div className="mt-8">
            <p className="text-gray-600 mb-4">Suivez-nous</p>
            <div className="flex justify-center space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-200 hover:bg-[#c4d600] rounded-full flex items-center justify-center transition-colors">
                <span className="text-gray-800">f</span>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-200 hover:bg-[#c4d600] rounded-full flex items-center justify-center transition-colors">
                <span className="text-gray-800">in</span>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-200 hover:bg-[#c4d600] rounded-full flex items-center justify-center transition-colors">
                <span className="text-gray-800">ig</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConseilsPage;